import {Bar} from 'recharts';

import {withStylesProvider} from '../../utils/withStylesProvider';
import {ChartTooltip} from '../ChartTooltip';

import {BarChart as Internal} from './BarChart';
import {StylesProvider} from './context';
import {barChartStyleConfig} from './theme';

type BarChartType = typeof Internal & {
  Tooltip: typeof ChartTooltip;
  Bar: typeof Bar;
};

const BarChart = withStylesProvider(Internal, StylesProvider, barChartStyleConfig) as BarChartType;
BarChart.Tooltip = ChartTooltip;
BarChart.Bar = Bar;

export {BarChart};
